import { formatLongDate } from '../../../common/utilities/date-formatter';
import { useHomeStore } from '../../../stores/home-store';
import ViewToggle from './view-toggle';
import FilterView from './filter-view';
import './home-toolbar.scss';

export default function HomeToolbar() {
  const [fromDate] = useHomeStore(store => store.fromDate);
  const [toDate] = useHomeStore(store => store.toDate);

  const dateRangeLabel =
    fromDate.toDateString() === toDate.toDateString()
      ? formatLongDate(fromDate)
      : `${formatLongDate(fromDate)} - ${formatLongDate(toDate)}`;

  return (
    <div className="home-toolbar" data-testid="home_toolbar">
      <div className="home-toolbar-top d-flex align-items-center justify-content-end">
        <ViewToggle />
      </div>

      <div className="home-toolbar-date-bar d-flex align-items-center justify-content-between">
        <span className="home-toolbar-date-label">{dateRangeLabel}</span>
        <FilterView />
      </div>
    </div>
  );
}
